import { differenceInCalendarDays } from 'date-fns'

import type {
  IParcela,
  TValorPresenteParcelaPontoMedio,
} from '@/features/simulador/shared/types/calculadora-parcela.types'

export class CalculadoraDeValorPresenteBase {
  calcularValorPresenteDasParcelas(parcelas: IParcela[], dataSimulacao: string, taxaDiaria: number) {
    const parcelaSaldo = parcelas.find((parcela) => parcela.tipo === 'saldo')
    return parcelas.map((parcela) => {
      const dataParcela = parcela.tipo === 'posConclusao' && parcelaSaldo?.data ? parcelaSaldo.data : parcela.data
      const quantidadeDias = differenceInCalendarDays(new Date(dataParcela), new Date(dataSimulacao))
      const valorPresente = parcela.valor / (1 + taxaDiaria) ** quantidadeDias
      return { ...parcela, valorPresente }
    })
  }

  calcularValorPresenteNoPontoMedio({
    valorPresente,
    taxaJurosDiarioDepoisPontoMedio,
    dataPontoMedio,
    dataSimulacao,
  }: TValorPresenteParcelaPontoMedio): number {
    const quantidadeDias = differenceInCalendarDays(new Date(dataPontoMedio), new Date(dataSimulacao))
    const valorPresentePontoMedio = valorPresente * (1 + taxaJurosDiarioDepoisPontoMedio) ** quantidadeDias
    return valorPresentePontoMedio
  }

  calcularValorPresenteNoPontoMedioEmUPF(valorPresentePontoMedio: number, taxaUPF: number): number {
    return valorPresentePontoMedio / taxaUPF
  }
}
